import { storeReturnTo } from "./storage"

export function safeReturnToPath(value: string | null) {
  if (!value?.startsWith("/") || value.startsWith("//")) return null
  if (value === "/" || value.startsWith("/login") || value.startsWith("/auth/sign-in") || value.startsWith("/callback")) {
    return null
  }
  return value
}

export function persistAuthSignInReturnTo(search: string, store = storeReturnTo) {
  const returnTo = safeReturnToPath(new URLSearchParams(search).get("returnTo"))
  if (returnTo) store(returnTo)
  return returnTo
}
